import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initConsoleRecorder } from './utils/consoleRecorder';

// Initialize in-memory console recorder for error & feedback diagnostics
initConsoleRecorder();

// Service Worker Registration for PWA + Push Notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Dashboard SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('Dashboard SW registration failed: ', registrationError);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
